export default {
  "config": {
    "trial": "tones-5",
    "id": "baseline-char",
    "type": "table",
    "title": "Demographic and Clinical Characteristics (Safety Population)<sup>14</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<sup>a</sup>Solriamfetol doses include <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>"
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-5",
    "id": "baseline-char",
    "data-type": "table",
    "title": "Demographic and Clinical Characteristics (Safety Population)<sup>14</sup>",
    "num-header-rows": 2,
    "num-columns": 4,
    "col-classes": [
      "col-1",
      "maintenance",
      "rwp",
      "rwp"
    ],
    "row-mergeoption": [
      1,
      2
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-a": "<sup>a</sup>Solriamfetol doses include <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 2,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Randomized withdrawal phase<b></center>",
          "cols": 2,
          "class": "rwp"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>Variable</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Maintenance phase <no-break>(N = 643)</no-break></b>",
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "<b>Placebo <no-break>(n = 142)</no-break></b>",
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol<sup>a</sup> <no-break>(n = 140)</no-break></b>",
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Age, years, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "49.3 (14.2)",
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "50.7 (12.1)",
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "50.2 (13.2)",
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Male, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "337 (52.4)",
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "85 (59.9)",
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "76 (54.3)",
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Race, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1",
          "parentRow": true,
          "parent": 4
        },
        {
          "content": null,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "content": null,
          "cols": 1,
          "class": "rwp"
        },
        {
          "content": null,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-5": [
        {
          "indent": 1,
          "parent": 4,
          "content": "White",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "506 (78.7)",
          "parent": 4,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "110 (77.5)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "112 (80.0)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Black/African American",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "109 (17.0)",
          "parent": 4,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "25 (17.6)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "25 (17.9)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-7": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Asian",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "15 (2.3)",
          "parent": 4,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "5 (3.5)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "3 (2.1)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-8": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Other",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "13 (2.0)",
          "parent": 4,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "2 (1.4)",
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        },
        {
          "content": 0,
          "parent": 4,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-9": [
        {
          "indent": 0,
          "content": "BMI, kg/m<sup>2</sup>, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "31.7 (5.9)",
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "31.8 (6.0)",
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "31.9 (5.7)",
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-10": [
        {
          "indent": 0,
          "content": "Disease, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1",
          "parentRow": true,
          "parent": 10
        },
        {
          "content": null,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "content": null,
          "cols": 1,
          "class": "rwp"
        },
        {
          "content": null,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-11": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Narcolepsy",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "226 (35.1)",
          "parent": 10,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "40 (28.2)",
          "parent": 10,
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "39 (27.9)",
          "parent": 10,
          "cols": 1,
          "class": "rwp"
        }
      ],
      "row-12": [
        {
          "indent": 1,
          "parent": 10,
          "content": "OSA",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "417 (64.9)",
          "parent": 10,
          "cols": 1,
          "class": "maintenance"
        },
        {
          "indent": 0,
          "content": "102 (71.8)",
          "parent": 10,
          "cols": 1,
          "class": "rwp"
        },
        {
          "indent": 0,
          "content": "101 (72.1)",
          "parent": 10,
          "cols": 1,
          "class": "rwp"
        }
      ]
    }
  }
};